import {
  Activity,
  AtSign,
  Award,
  Badge,
  BadgeAlert,
  BadgeCent,
  BadgeCheck,
  BadgeDollarSign,
  BadgeEuro,
  BadgeHelp,
  BadgeInfo,
  BadgeMinus,
  BadgePercent,
  BadgePoundSterling,
  BadgeX,
  Ban,
  Bell,
  BellDot,
  BetweenHorizonalEnd,
  BetweenHorizonalStart,
  Bolt,
  BookUser,
  Bookmark,
  BookmarkCheck,
  BookmarkMinus,
  BookmarkPlus,
  BookmarkX,
  Building,
  Building2,
  Cake,
  Circle,
  CircleGauge,
  CirclePercent,
  CircleUser,
  CircleUserRound,
  ClipboardPenLine,
  Cog,
  Contact,
  ContactRound,
  Cookie,
  CreditCard,
  DiamondPercent,
  Facebook,
  Fingerprint,
  Flag,
  FlagOff,
  Frown,
  Gauge,
  Gift,
  HandCoins,
  Handshake,
  HeartHandshake,
  Home,
  Inbox,
  Key,
  KeyRound,
  KeySquare,
  Link,
  Link2,
  Linkedin,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  MapPinned,
  Menu,
  MessageCircle,
  MessageCircleCode,
  MessageCircleDashed,
  MessageCircleMore,
  MessageCircleOff,
  MessageCirclePlus,
  MessageCircleQuestion,
  MessageCircleReply,
  MessageCircleWarning,
  MessageCircleX,
  MessageSquare,
  MessageSquareCode,
  MessageSquareDashed,
  MessageSquareDiff,
  MessageSquareDot,
  MessageSquareMore,
  MessageSquareOff,
  MessageSquarePlus,
  MessageSquareQuote,
  MessageSquareReply,
  MessageSquareShare,
  MessageSquareText,
  MessageSquareWarning,
  MessageSquareX,
  MessagesSquare,
  NotebookTabs,
  Pin,
  Printer,
  ScanEye,
  ScanFace,
  Search,
  SearchCheck,
  SearchCode,
  SearchSlash,
  SearchX,
  Settings,
  Settings2,
  Shapes,
  Share,
  Share2,
  Shield,
  ShieldAlert,
  ShieldBan,
  ShieldCheck,
  ShieldEllipsis,
  ShieldHalf,
  ShieldMinus,
  ShieldOff,
  ShieldPlus,
  ShieldQuestion,
  ShieldX,
  Slack,
  Smile,
  SquareActivity,
  SquareAsterisk,
  SquareMenu,
  SquarePercent,
  SquareUser,
  SquareUserRound,
  Star,
  Tag,
  Tags,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  TicketCheck,
  TicketMinus,
  TicketPercent,
  TicketPlus,
  TicketSlash,
  TicketX,
  ToggleLeft,
  ToggleRight,
  Trello,
  Twitch,
  Twitter,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserRound,
  UserRoundCheck,
  UserRoundCog,
  UserRoundMinus,
  UserRoundPlus,
  UserRoundSearch,
  UserRoundX,
  UserSearch,
  UserX,
  Users,
  UsersRound,
  VenetianMask,
  Vibrate,
  VibrateOff,
  WalletCards,
  Webhook,
  WebhookOff,
  Wrench,
  Youtube,
} from "lucide-react";

export const icons: any = {
  circle: (props: any) => <Circle {...props} />,
  home: (props: any) => <Home {...props} />,
  activity: (props: any) => <Activity {...props} />,
  "at-sign": (props: any) => <AtSign {...props} />,
  award: (props: any) => <Award {...props} />,
  "badge-alert": (props: any) => <BadgeAlert {...props} />,
  "badge-cent": (props: any) => <BadgeCent {...props} />,
  "badge-check": (props: any) => <BadgeCheck {...props} />,
  "badge-dollar-sign": (props: any) => <BadgeDollarSign {...props} />,
  "badge-euro": (props: any) => <BadgeEuro {...props} />,
  "badge-help": (props: any) => <BadgeHelp {...props} />,
  "badge-info": (props: any) => <BadgeInfo {...props} />,
  "badge-minus": (props: any) => <BadgeMinus {...props} />,
  "badge-percent": (props: any) => <BadgePercent {...props} />,
  "badge-pound-sterling": (props: any) => <BadgePoundSterling {...props} />,
  "badge-x": (props: any) => <BadgeX {...props} />,
  badge: (props: any) => <Badge {...props} />,
  ban: (props: any) => <Ban {...props} />,
  "bell-dot": (props: any) => <BellDot {...props} />,
  bell: (props: any) => <Bell {...props} />,
  "between-horizontal-end": (props: any) => <BetweenHorizonalEnd {...props} />,
  "between-horizontal-start": (props: any) => (
    <BetweenHorizonalStart {...props} />
  ),
  bolt: (props: any) => <Bolt {...props} />,
  "book-user": (props: any) => <BookUser {...props} />,
  "bookmark-check": (props: any) => <BookmarkCheck {...props} />,
  "bookmark-minus": (props: any) => <BookmarkMinus {...props} />,
  "bookmark-plus": (props: any) => <BookmarkPlus {...props} />,
  "bookmark-x": (props: any) => <BookmarkX {...props} />,
  bookmark: (props: any) => <Bookmark {...props} />,
  "building-2": (props: any) => <Building2 {...props} />,
  building: (props: any) => <Building {...props} />,
  cake: (props: any) => <Cake {...props} />,
  "circle-gauge": (props: any) => <CircleGauge {...props} />,
  "circle-percent": (props: any) => <CirclePercent {...props} />,
  "circle-user-round": (props: any) => <CircleUserRound {...props} />,
  "circle-user": (props: any) => <CircleUser {...props} />,
  "clipboard-pen-line": (props: any) => <ClipboardPenLine {...props} />,
  cog: (props: any) => <Cog {...props} />,
  "contact-round": (props: any) => <ContactRound {...props} />,
  contact: (props: any) => <Contact {...props} />,
  cookie: (props: any) => <Cookie {...props} />,
  "credit-card": (props: any) => <CreditCard {...props} />,
  "diamond-percent": (props: any) => <DiamondPercent {...props} />,

  facebook: (props: any) => <Facebook {...props} />,
  fingerprint: (props: any) => <Fingerprint {...props} />,
  "flag-off": (props: any) => <FlagOff {...props} />,
  flag: (props: any) => <Flag {...props} />,
  frown: (props: any) => <Frown {...props} />,
  gauge: (props: any) => <Gauge {...props} />,
  gift: (props: any) => <Gift {...props} />,
  "hand-coins": (props: any) => <HandCoins {...props} />,
  handshake: (props: any) => <Handshake {...props} />,
  "heart-handshake": (props: any) => <HeartHandshake {...props} />,
  inbox: (props: any) => <Inbox {...props} />,
  "key-round": (props: any) => <KeyRound {...props} />,
  "key-square": (props: any) => <KeySquare {...props} />,
  key: (props: any) => <Key {...props} />,
  "link-2": (props: any) => <Link2 {...props} />,
  link: (props: any) => <Link {...props} />,
  linkedin: (props: any) => <Linkedin {...props} />,
  "log-in": (props: any) => <LogIn {...self.props} />,
  "log-out": (props: any) => <LogOut {...self.props} />,
  mail: (props: any) => <Mail {...props} />,
  "map-pin": (props: any) => <MapPin {...props} />,
  "map-pinned": (props: any) => <MapPinned {...props} />,
  menu: (props: any) => <Menu {...props} />,
  "message-circle-code": (props: any) => <MessageCircleCode {...props} />,
  "message-circle-dashed": (props: any) => <MessageCircleDashed {...props} />,
  "message-circle-more": (props: any) => <MessageCircleMore {...props} />,
  "message-circle-off": (props: any) => <MessageCircleOff {...props} />,
  "message-circle-plus": (props: any) => <MessageCirclePlus {...props} />,
  "message-circle-question": (props: any) => (
    <MessageCircleQuestion {...props} />
  ),
  "message-circle-reply": (props: any) => <MessageCircleReply {...props} />,
  "message-circle-warning": (props: any) => <MessageCircleWarning {...props} />,
  "message-circle-x": (props: any) => <MessageCircleX {...props} />,
  "message-circle": (props: any) => <MessageCircle {...props} />,
  "message-square-code": (props: any) => <MessageSquareCode {...props} />,
  "message-square-dashed": (props: any) => <MessageSquareDashed {...props} />,
  "message-square-diff": (props: any) => <MessageSquareDiff {...props} />,
  "message-square-dot": (props: any) => <MessageSquareDot {...props} />,
  "message-square-more": (props: any) => <MessageSquareMore {...props} />,
  "message-square-off": (props: any) => <MessageSquareOff {...props} />,
  "message-square-plus": (props: any) => <MessageSquarePlus {...props} />,
  "message-square-quote": (props: any) => <MessageSquareQuote {...props} />,
  "message-square-reply": (props: any) => <MessageSquareReply {...props} />,
  "message-square-share": (props: any) => <MessageSquareShare {...props} />,
  "message-square-text": (props: any) => <MessageSquareText {...props} />,
  "message-square-warning": (props: any) => <MessageSquareWarning {...props} />,
  "message-square-x": (props: any) => <MessageSquareX {...props} />,
  "message-square": (props: any) => <MessageSquare {...props} />,
  "messages-square": (props: any) => <MessagesSquare {...props} />,
  "notebook-tabs": (props: any) => <NotebookTabs {...props} />,
  pin: (props: any) => <Pin {...props} />,
  printer: (props: any) => <Printer {...props} />,
  "scan-eye": (props: any) => <ScanEye {...props} />,
  "scan-face": (props: any) => <ScanFace {...props} />,
  "search-check": (props: any) => <SearchCheck {...props} />,
  "search-code": (props: any) => <SearchCode {...props} />,
  "search-slash": (props: any) => <SearchSlash {...props} />,
  "search-x": (props: any) => <SearchX {...props} />,
  search: (props: any) => <Search {...props} />,
  "settings-2": (props: any) => <Settings2 {...props} />,
  settings: (props: any) => <Settings {...props} />,
  shapes: (props: any) => <Shapes {...props} />,
  "share-2": (props: any) => <Share2 {...props} />,
  share: (props: any) => <Share {...props} />,
  "shield-alert": (props: any) => <ShieldAlert {...props} />,
  "shield-ban": (props: any) => <ShieldBan {...props} />,
  "shield-check": (props: any) => <ShieldCheck {...props} />,
  "shield-ellipsis": (props: any) => <ShieldEllipsis {...props} />,
  "shield-half": (props: any) => <ShieldHalf {...props} />,
  "shield-minus": (props: any) => <ShieldMinus {...props} />,
  "shield-off": (props: any) => <ShieldOff {...props} />,
  "shield-plus": (props: any) => <ShieldPlus {...props} />,
  "shield-question": (props: any) => <ShieldQuestion {...props} />,
  "shield-x": (props: any) => <ShieldX {...props} />,
  shield: (props: any) => <Shield {...props} />,
  slack: (props: any) => <Slack {...props} />,
  smile: (props: any) => <Smile {...props} />,
  "square-activity": (props: any) => <SquareActivity {...props} />,
  "square-asterisk": (props: any) => <SquareAsterisk {...props} />,
  "square-menu": (props: any) => <SquareMenu {...props} />,
  "square-percent": (props: any) => <SquarePercent {...props} />,
  "square-user-round": (props: any) => <SquareUserRound {...props} />,
  "square-user": (props: any) => <SquareUser {...props} />,
  star: (props: any) => <Star {...props} />,
  tag: (props: any) => <Tag {...props} />,
  tags: (props: any) => <Tags {...props} />,
  "thumbs-down": (props: any) => <ThumbsDown {...props} />,
  "thumbs-up": (props: any) => <ThumbsUp {...props} />,
  "ticket-check": (props: any) => <TicketCheck {...props} />,
  "ticket-minus": (props: any) => <TicketMinus {...props} />,
  "ticket-percent": (props: any) => <TicketPercent {...props} />,
  "ticket-plus": (props: any) => <TicketPlus {...props} />,
  "ticket-slash": (props: any) => <TicketSlash {...props} />,
  "ticket-x": (props: any) => <TicketX {...props} />,
  ticket: (props: any) => <Ticket {...props} />,
  "toggle-left": (props: any) => <ToggleLeft {...props} />,
  "toggle-right": (props: any) => <ToggleRight {...props} />,
  trello: (props: any) => <Trello {...props} />,
  twitch: (props: any) => <Twitch {...props} />,
  twitter: (props: any) => <Twitter {...props} />,
  "user-check": (props: any) => <UserCheck {...props} />,
  "user-cog": (props: any) => <UserCog {...props} />,
  "user-minus": (props: any) => <UserMinus {...props} />,
  "user-plus": (props: any) => <UserPlus {...props} />,
  "user-round-check": (props: any) => <UserRoundCheck {...props} />,
  "user-round-cog": (props: any) => <UserRoundCog {...props} />,
  "user-round-minus": (props: any) => <UserRoundMinus {...props} />,
  "user-round-plus": (props: any) => <UserRoundPlus {...props} />,
  "user-round-search": (props: any) => <UserRoundSearch {...props} />,
  "user-round-x": (props: any) => <UserRoundX {...props} />,
  "user-round": (props: any) => <UserRound {...props} />,
  "user-search": (props: any) => <UserSearch {...props} />,
  "user-x": (props: any) => <UserX {...props} />,
  user: (props: any) => <User {...props} />,
  "users-round": (props: any) => <UsersRound {...props} />,
  users: (props: any) => <Users {...props} />,
  "venetian-mask": (props: any) => <VenetianMask {...props} />,
  "vibrate-off": (props: any) => <VibrateOff {...props} />,
  vibrate: (props: any) => <Vibrate {...props} />,
  "wallet-cards": (props: any) => <WalletCards {...props} />,
  "wallet-minivarte-off": (props: any) => <WebhookOff {...props} />,
  webhook: (props: any) => <Webhook {...props} />,
  wrench: (props: any) => <Wrench {...props} />,
  youtube: (props: any) => <Youtube {...props} />,
};

const AccountIcon = (props: {
  name: string;
  className?: string;
  strokeWidth?: number;
  color?: string;
  size?: number;
}) => {
  const { name, ...restProps } = props;
  let result = <Circle {...restProps} />;
  if (name) {
    result = icons[name]({ ...restProps });
  }
  return result;
};

export default AccountIcon;
